import { createFileRoute } from "@tanstack/react-router"
import { AixContentBody } from "@aix/ui"
import { useAtomValue } from "jotai"
import { ReactElement } from "react"
import ScriptWriterTool from "~/components/Steppers/ScriptWriterTool"
import CustomHead from "~/components/SEOHead/CustomHead"
import AppLayout from "~/layouts/AppLayout"
import { BreadcrumbBanner } from "~/components/BreadcrumbBanner"
import { navStyleAtom } from "~/context/jotai"
import { getPageSEO } from "~/utils/seo"

function ScriptWriterPage() {
  const breadcrumbItems = [{ label: "Home", href: "/home" }, { label: "AI Script Writer" }]
  const scriptWriterSEO = getPageSEO("tools/script-writer")
  const navStyle = useAtomValue(navStyleAtom)

  return (
    <>
      {navStyle !== "twoTier" && <BreadcrumbBanner items={breadcrumbItems} />}
      <CustomHead
        title={scriptWriterSEO.title}
        description={scriptWriterSEO.description}
        keywords={scriptWriterSEO.keywords}
        pageType={scriptWriterSEO.pageType}
        url="https://vidmax.ai/tools/script-writer"
      />
      <div className="space-y-6">
        <AixContentBody>
          <ScriptWriterTool />
        </AixContentBody>
      </div>
    </>
  )
}

function ScriptWriterPageWrapper() {
  return (
    <AppLayout>
      <ScriptWriterPage />
    </AppLayout>
  )
}

export const Route = createFileRoute("/tools/script-writer")({
  component: ScriptWriterPageWrapper,
})
